import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../../services/loader.service';
import {TranslateService} from '@ngx-translate/core';
import { DataService } from '../../services/data.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req);
};
